// extracted by mini-css-extract-plugin
module.exports = {"countdown":"eo-z","srOnly":"fo-z"};